import { createIcon } from '@mote/ui/components/icon'
import { defaultProps } from './defaultProps'

export const InfoOutlineIcon = createIcon({
  displayName: 'InfoOutlineIcon',
  path: [
    <path
      d='M12 13V15'
      stroke='currentColor'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />,
    <path
      d='M12 10C12.5523 10 13 9.55228 13 9C13 8.44772 12.5523 8 12 8C11.4477 8 11 8.44772 11 9C11 9.55228 11.4477 10 12 10Z'
      fill='currentColor'
    />,
    <path
      d='M12 19.25C16.0041 19.25 19.25 16.0041 19.25 12C19.25 7.99594 16.0041 4.75 12 4.75C7.99594 4.75 4.75 7.99594 4.75 12C4.75 16.0041 7.99594 19.25 12 19.25Z'
      stroke='currentColor'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  ],
  defaultProps: defaultProps
})
